<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警语音
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1 deviceDialogs">
          <el-form ref="searchForm_jsgl">
              <el-form-item label="开始时间" prop="beginTime">
                <el-date-picker v-model="formData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker v-model="formData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="手机号码">
                <el-input placeholder="请输入手机号码" v-model="formData.phone"></el-input>
              </el-form-item>
              <el-form-item label="语音内容">
                <el-input placeholder="请输入语音内容" v-model="formData.msg"></el-input>
              </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper deviceTable" v-loading="!showTable">
          <el-table :data="tableData" style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"  class="stripeTable" max-height='500px' @selection-change="checkSelect" ref="Table" :row-key="getRowKey">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key='prop.toString()'>
            </el-table-column>
              <el-table-column label="操作" width="100" align="left">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconwhole" type="text" size="small" @click="$refs.alarmDetail.look(scope.$index, scope.row,false)">详情</el-link>
                </template>
              </el-table-column>

          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <alarm-detail ref="alarmDetail"></alarm-detail>

  </div>
</template>

<script>
export default {
  data() {
    return {
       formData: {
        pageNum: 1,
        pageSize: 10,
        startTime: new Date(new Date().toLocaleDateString()),
        endTime: new Date(),
        phone: "",
        msg: "",
      },
      tabName: "jsgl",
      showTable: true,
      loading: true,
      //分页
      message: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [],
      config: [
       {
          prop: "sendTime",
          label: "发送时间",
        },
       {
          prop: "phone",
          label: "手机号码",
        },
        {
          prop: "msgContent",
          label: "语音内容",
        }
      ],
      nTotal: 0,
      time: true
    };
  },
  components: {
    normalNav: () => import("public/normalNav"),
    alarmDetail: () => import("./alarmDetail"),
    searchForm: () => import("public/searchForm"),
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    handleCurrentChange(val) {
      this.loading = true
      this.formData.pageNum = val;
      this.getTableList();
    },
    getTableList() {
      this.$axiosget("operation/msgRecord/findAllMsg?type=2", {
        params: { ...this.formData },
      }).then(res => {
        this.tableData = res.data.data.list;
        this.nTotal = res.data.data.total;
        this.loading = false
      });
    },
    rowKey(row) {
      return row.id;
    },
    //搜索
    subSeefrom() {
      this.loading = true
      this.getDate()
      this.getTableList();
    },
    //重置
    reset() {
      this.formData = {
        startTime: new Date(new Date().toLocaleDateString()),
        endTime: new Date(),
        phone: "",
        msg: ""
      },
      this.time = true
    },
    checkSelect(data) {
      if (data.length > 1) {
        this.$refs.Table.clearSelection();
        this.$refs.Table.toggleRowSelection(data.pop());
      } else if (data.length == 1) {
        this.deviceId = data[0].device_mark;
        this.changeDevice = data[0];
      }
    },
    getDate(){
      if (this.time){
        let date = new Date()
        let y = date.getFullYear()
        let m = date.getMonth()+1
        let d = date.getDate()
        let h = date.getHours()
        let f = date.getMinutes()
        let s = date.getSeconds()
        //  "2021-04-13 11:32:53"
        m = m > 9  ? m :  '0' + m
        d = d > 9  ? d :  '0' + d
        h = h > 9  ? h :  '0' + h
        f = f > 9  ? f :  '0' + f
        s = s > 9  ? s :  '0' + s
        this.formData.startTime = y + "-" + m + "-" + d + " " + "00:00:00"
        this.formData.endTime = y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s
        this.time = false
      }
    },
  },
  mounted() {
    this.getDate()
    this.getTableList();
  },

};
</script>

<style lang="less" scoped>
.content {
  /deep/ .el-input{
    width: 100%;
  }
  /deep/  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  /deep/  .el-table__row td{
    border:none;
    padding:0;
  }
  /deep/  .el-table td,
  /deep/ .el-table th.is-leaf{
    border: none;
  }
  /deep/  .deviceTable
  /deep/ .el-table__row td{
    border: none;
    padding: 0;
  }
  /deep/  .deviceTable{
    background: none;
    padding : 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/alarmVoice.vue